import { px2rem, inPixels } from '../utils/helpers/style.js';

var sizings = {
  s: {
    containerHeight: px2rem(40),
    logoHeight: inPixels(24),
    paddingVertical: px2rem(8),
    paddingHorizontal: px2rem(12)
  },
  m: {
    containerHeight: px2rem(56),
    logoHeight: inPixels(32),
    paddingVertical: px2rem(12),
    paddingHorizontal: px2rem(12)
  },
  l: {
    containerHeight: px2rem(72),
    logoHeight: inPixels(40),
    paddingVertical: px2rem(16),
    paddingHorizontal: px2rem(12)
  }
};
var fortumLogoThemeWeb = {
  sizings: sizings
};

export { fortumLogoThemeWeb };
